import Glide from "@glidejs/glide";
import { getElements, getElement, ifSelectorExist } from "./utils";

function GlideAutoHeight(Glide, Components, Events) {
  const Component = {
    mount() {
      if (!Glide.settings.autoHeight) return;
      Components.Html.track.style.transition = "height 200ms ease-in-out";
      this.updateTrackHeight();
    },

    updateTrackHeight() {
      if (!Glide.settings.autoHeight) return;

      const activeSlides = Components.Html.slides.filter((slide, index) => {
        return (
          index >= Glide.index &&
          index <= Glide.index - 1 + Glide.settings.perView
        );
      });

      const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
        return Math.max(maxHeight, slide.offsetHeight);
      }, 0);

      const glideTrack = Components.Html.track;
      if (newMaxHeight !== glideTrack.offsetHeight) {
        glideTrack.style.height = `${newMaxHeight}px`;
      }
    },
  };

  Events.on("run", () => {
    Component.updateTrackHeight();
  });
  Events.on("update", () => {
    Component.updateTrackHeight();
  });
  Events.on("resize", () => {
    Component.updateTrackHeight();
  });

  return Component;
}

export const sliders = () => {
  const settlementsSlider = ".settlements_slider";
  if (
    document.querySelector(settlementsSlider) != undefined &&
    document.querySelector(settlementsSlider) != null
  ) {
    let settlementsSliderPerView = parseInt(
      document.querySelector(settlementsSlider).getAttribute("data-per-view")
    );

    if (isNaN(settlementsSliderPerView)) {
      settlementsSliderPerView = 4.2;
    }

    Array.from(getElements(settlementsSlider)).forEach((item) => {
      new Glide(item, {
        type: "carousel",
        autoplay: 1,
        animationDuration: 3500,
        animationTimingFunc: "linear",
        perView: settlementsSliderPerView,
        breakpoints: {
          1496: {
            perView: settlementsSliderPerView,
          },
          1170: {
            perView: 3,
          },
          767: {
            perView: 2,
          },
          470: {
            perView: 1,
            autoplay: 0,
            gap: 10,
            animationDuration: 500,
          },
        },
      }).mount();
    });
  }

  const knoxMansionSlider = ".knox_mansion_slider";
  if (
    document.querySelector(knoxMansionSlider) != undefined &&
    document.querySelector(knoxMansionSlider) != null
  ) {
    let knoxMansionSliderPerView = parseInt(
      document.querySelector(knoxMansionSlider).getAttribute("data-per-view")
    );

    if (isNaN(knoxMansionSliderPerView)) {
      knoxMansionSliderPerView = 2;
    }

    Array.from(getElements(knoxMansionSlider)).forEach((item) => {
      new Glide(item, {
        type: "carousel",
        perView: knoxMansionSliderPerView,
        breakpoints: {
          1496: {
            perView: knoxMansionSliderPerView,
          },
          1170: {
            perView: 2,
          },
          767: {
            perView: 2,
          },
          470: {
            perView: 1,
            autoplay: 0,
            gap: 10,
          },
        },
      }).mount();
    });
  }

  const testimonialsSlider = ".testimonials_slider";
  if (
    document.querySelector(testimonialsSlider) != undefined &&
    document.querySelector(testimonialsSlider) != null
  ) {
    Array.from(getElements(testimonialsSlider)).forEach((item) => {
      new Glide(item, {
        type: "carousel",
        animationDuration: 2000,
        perView: 3,
        breakpoints: {
          1024: {
            perView: 1,
          },
        },
      }).mount();
    });
  }

  const testimonialsSliderProgress = ".testimonials_slider--progress";
  if (
    document.querySelector(testimonialsSliderProgress) != undefined &&
    document.querySelector(testimonialsSliderProgress) != null
  ) {
    const CustomLength = function (Glide, Components, Events) {
      return {
        mount() {
          Events.emit("slider.length", Components.Sizes.length);
          // console.log('Console log', Components.Sizes.length)
        },
      };
    };

    Array.from(getElements(testimonialsSliderProgress)).forEach((item) => {
      const glideProgress = new Glide(item, {
        type: "carousel",
        animationDuration: 1500,
        perView: 1,
        autoplay: 6000,
        gap: "50px",
        peek: {
          before: 10,
          after: 0,
        },
        customLength: CustomLength,
      });

      glideProgress.on("run.after", function (event) {
        const progressBar = getElement(".glide__progress-bar");
        if (glideProgress.settings.customLength.length > 0) {
          const progress = ((glideProgress.index + 1) / 6) * 100;
          progressBar.style.width = progress + "%";
        }
      });

      glideProgress.on("mount.before", function (event) {
        const progressBar = getElement(".glide__progress-bar");
        if (glideProgress.settings.customLength.length > 0) {
          const progress = ((glideProgress.index + 1) / 6) * 100;
          progressBar.style.width = progress + "%";
        }
      });

      glideProgress.mount({
        CustomLength,
      });
    });
  }
};
